import React from "react";
import { Link, EmptyState, Flex } from "@jsq/ds/core";
import { useDistributionWorkflowContext } from "../../Context/context";
import { DistributionWorkflowStepProps } from "../../types";
import { errorStepContainer } from "./styles_vanilla.css";

const ErrorStep: React.FC<DistributionWorkflowStepProps> = () => {
  const { errorMessage } = useDistributionWorkflowContext();
  return (
    <Flex className={errorStepContainer} alignItems="center" flexGrow={1}>
      <EmptyState
        illustration="document-failure"
        title="Payments batch not created"
        description={errorMessage}
      >
        <Link displayAsButton href="/canopy/treasury" variant="primary">
          Go to treasury dashboard
        </Link>
      </EmptyState>
    </Flex>
  );
};

export default ErrorStep;
